import React, { useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import {
  WContainer,
  Breadcrumbs,
  MainTitle,
  MainDescription,
  WImage,
  TabGroup,
  Accordion,
} from '@next-nx/shared-ui/atoms'
import { BlueImageIconsBox, ImageIconsBox, Page } from '@next-nx/shared-ui/organisms'
import styles from './NltVantaggiTemplate.module.sass'
import { BoxLink, IconTextDescriptionItem } from '@next-nx/shared-ui/molecules'

interface Props {
  pagina?: any
}

const NltVantaggiTemplate = (props: Props) => {
  const { pagina = {} } = props

  const t = useTrans()
  const paginaVantaggi = useFindMenu('pagina-vantaggi')
  const boxItem = useFindMenu('box-contattaci', paginaVantaggi)
  const vantaggiEconomici = useFindMenu('vantaggi-economici', paginaVantaggi)
  const vantaggiOperativi = useFindMenu('vantaggi-operativi', paginaVantaggi)
  const vantaggiFiscali = useFindMenu('vantaggi-fiscali', paginaVantaggi)
  const vantaggiFiscaliText = useFindMenu('vantaggi-fiscali-text', paginaVantaggi)
  const vantaggiFaq = useFindMenu('vantaggi-faq', paginaVantaggi)
  const maggioriInfo = useFindMenu('maggiori-info', paginaVantaggi)
  const [activeTab, setActiveTab] = useState(vantaggiEconomici?.key)

  const tabs: {
    key?: string
    label?: string
    disabled?: boolean
  }[] = [
    {
      key: vantaggiEconomici ? vantaggiEconomici?.key : '',
      label: vantaggiEconomici ? vantaggiEconomici?.name : '',
    },
    {
      key: vantaggiOperativi ? vantaggiOperativi?.key : '',
      label: vantaggiOperativi ? vantaggiOperativi?.name : '',
    },
    {
      key: vantaggiFiscali ? vantaggiFiscali?.key : '',
      label: vantaggiFiscali ? vantaggiFiscali?.name : '',
    },
  ]
  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
        <div className={styles.content}>
          <MainDescription html={pagina.descrizione} className={styles.descrizione} />
          <div className={styles.col}>
            {!!boxItem && (
              <BoxLink item={boxItem} className={styles.box} ctaVariant={'secondary'} />
            )}
          </div>
        </div>
      </WContainer>
      <TabGroup
        tabs={tabs}
        triggersClassName={styles.tabsTriggers}
        setExternalActiveTab={setActiveTab}
        triggerSlider={true}
        initialActiveTab={vantaggiEconomici?.key}
        className={styles.tabs}
      />

      {/* Desktop */}
      {!!vantaggiEconomici && (
        <ImageIconsBox item={vantaggiEconomici} className={`${styles.vantaggiEconomiciContent}`} />
      )}

      {/* Mobile */}
      {activeTab === vantaggiEconomici?.key && (
        <ImageIconsBox
          item={vantaggiEconomici}
          className={`${styles.vantaggiEconomiciContent} ${styles['vantaggiEconomiciContent--mobile']}`}
        />
      )}

      {/* Desktop */}
      {!!vantaggiOperativi && (
        <BlueImageIconsBox
          item={vantaggiOperativi}
          className={`${styles.vantaggiOperativiContent}`}
        />
      )}

      {/* Mobile */}
      {activeTab === vantaggiOperativi?.key && (
        <ImageIconsBox
          item={vantaggiOperativi}
          className={`${styles.vantaggiOperativiContent} ${styles['vantaggiOperativiContent--mobile']}`}
        />
      )}

      {/* Desktop */}
      {!!vantaggiFiscali?.children?.edges?.length && (
        <WContainer className={styles.vantaggiFiscaliContainer}>
          {!!vantaggiFiscali?.name && (
            <div className={styles.vantaggiFiscaliTitle}>{vantaggiFiscali.name}</div>
          )}
          <div className={styles.vantaggiFiscaliContent}>
            {vantaggiFiscali?.children?.edges?.map((x, index) => (
              <div className={styles.item}>
                <IconTextDescriptionItem item={x?.node} className={styles.item} />
              </div>
            ))}
          </div>
          {!!vantaggiFiscaliText?.descriptionHtml && (
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{
                __html: vantaggiFiscaliText?.descriptionHtml,
              }}
            ></div>
          )}
        </WContainer>
      )}

      {/* Mobile */}
      {!!vantaggiFiscali?.children?.edges?.length && activeTab === vantaggiFiscali?.key && (
        <WContainer
          className={`${styles.vantaggiFiscaliContainer} ${styles['vantaggiFiscaliContainer--mobile']}`}
        >
          {!!vantaggiFiscali?.name && (
            <div className={styles.vantaggiFiscaliTitle}>{vantaggiFiscali.name}</div>
          )}
          <div className={styles.vantaggiFiscaliContent}>
            {vantaggiFiscali?.children?.edges?.map((x, index) => (
              <div className={styles.item}>
                <IconTextDescriptionItem
                  item={x?.node}
                  className={styles.item}
                  useIconIdVariant={
                    x?.node?.style == 'faq_canone_mensile_illustration' ? true : false
                  }
                />
              </div>
            ))}
          </div>
          {!!vantaggiFiscaliText?.descriptionHtml && (
            <div
              className={`${styles.text} ${styles['text--mobile']}`}
              dangerouslySetInnerHTML={{
                __html: vantaggiFiscaliText?.descriptionHtml,
              }}
            ></div>
          )}
        </WContainer>
      )}

      {!!vantaggiFaq?.children?.edges?.length && (
        <WContainer>
          <div className={styles.vantaggiFaqContent}>
            {vantaggiFaq?.children?.edges?.map((x, index) => (
              <Accordion
                label={x.node.name}
                content={x.node.descriptionHtml}
                className={styles.itemFaq}
                labelClassName={styles.itemFaqLabel}
              />
            ))}
          </div>
        </WContainer>
      )}

      {!!maggioriInfo?.descriptionHtml && (
        <WContainer>
          <div
            className={`${styles.maggioriInfoContainer} ${styles['maggioriInfoContainer--mobile']}`}
          >
            <div
              className={`${styles.text} ${styles['text--mobile']}`}
              dangerouslySetInnerHTML={{
                __html: maggioriInfo?.descriptionHtml,
              }}
            />
          </div>
        </WContainer>
      )}
    </Page>
  )
}

export default NltVantaggiTemplate
